import { styled } from '@mui/system';

export const MarkerPart = styled('span', { shouldForwardProp: prop => prop !== 'isMarked' })<{ isMarked: boolean }>(
  ({ theme, isMarked }) => ({
    color: isMarked ? theme.palette.text.primary : 'inherit',
    fontWeight: isMarked ? 'bold' : 'inherit'
  })
);
